var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-relative tw-h-1.5 tw-overflow-hidden tw-rounded-full tw-bg-white/20"},[_c('div',{staticClass:"tw-h-full tw-w-full tw-flex-1 tw-bg-white tw-transition-all",style:({ transform: `translateX(-${_vm.progress}%)` })})])
}
var staticRenderFns = []

export { render, staticRenderFns }